import React, {Fragment, useContext, useEffect, useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {Modal, Responsive, Dropdown, Loader, Dimmer, Grid, Segment, Container, Item, Icon, Button, Image, SegmentInline} from 'semantic-ui-react';
import {AppContext} from "../../context/app/appContext";
import axios from "axios";
import {toast} from 'react-toastify';

export const Sidebar = (props) => {
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    const accessToken = localStorage.getItem('accessToken');
    
    const [activeItem, setActiveItem] = useState('Home');
    const [screenWidth, setScreenWidth] = useState(null);
    const [fundLoading, setFundLoading] = useState(false);
    const history = useHistory();
    const appContext = useContext(AppContext);
    const [showConfirmFundModal, setShowConfirmFundModal] = useState(false);
    const [hasSomeBudget, setHasSomeBudget] = useState(false);
    const [requiredFund, setRequiredFund] = useState(0);
    const [numEmployees, setNumEmployees] = useState(0)

    const subscriptionPlans = [
        {key: 1, text: "Annual Plan ($3.19/employee)", value: "annual", price: 3.19},
        {key: 2, text: "Monthly Plan ($3.99/employee)", value: "monthly", price: 3.99},
        {key: 3, text: "Free Trial ($0/employee)", value: "free-trial", price: 0}
    ];

    const [selectedPlanPrice, setSelectedPlanPrice] = useState(null);
    const [selectedSubscriptionPlanValue, setSelectedSubscriptionPlanValue] = useState(null);
    const [selectedSubscriptionPlanTitle, setSelectedSubscriptionPlanTitle] = useState(null);

    let location = useLocation();
    console.log(location.pathname);

    useEffect(() => {
        (async function checkValidTopken() {
            const response = await axios.post(baseURL + '/verify-token', {accessToken});
            console.info({response})
            const validToken = response.data.status.message === 'unauthorizedAccess' ? false : true;
            if(!validToken){
                appContext.logOut();
                localStorage.removeItem('accessToken');
                localStorage.removeItem('email');
                localStorage.removeItem('user');
                localStorage.removeItem('organization');
                history.push(`/login`);
            }
        })();
    })

    useEffect(() => {
        if(appContext.organization.subscription !== undefined && appContext.organization.subscription.length){
            console.info({thissssssssss: appContext.organization.subscription})
            const currentPlan = subscriptionPlans.filter(plan => {return plan.value === appContext.organization.subscription})[0];
            setSelectedPlanPrice(currentPlan.price);
            setSelectedSubscriptionPlanValue(currentPlan.value);
            setSelectedSubscriptionPlanTitle(currentPlan.text);
        }
        
    }, [appContext.organization.subscription])

    useEffect(() => {
        // if(hasSomeBudget && appContext.teams.length && appContext.emloyees.length){
            var total = 0;
            console.log("Teams")
            appContext.teams.forEach(team => {
                if(team.budget > 0){
                    var numPerkEmployees = appContext.employees.filter(employee => {return (employee.teamId === team.id)}).length
                    total += numPerkEmployees * team.budget;
                }
                if(team.expenseLimit > 0){
                    var numExpenseEmployees = appContext.employees.filter(employee => {return (employee.teamId === team.id && (employee.expenseStatus === 'activateHR' || employee.expenseStatus === 'activateEmployee'))}).length
                    total += numExpenseEmployees * team.expenseLimit
                }
            });
            console.log("Total: "+total)
            setRequiredFund(total)
        // }
    }, [appContext.teams, appContext.employees, appContext.organization.availableBudget, appContext.organization.expectedFundAvailability, hasSomeBudget])

    useEffect(() => {
        if (!appContext.teams.length && appContext.organization.verified) {
            (async function loadTeams() {
                await appContext.loadTeams();
            })();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!appContext.employees.length && appContext.organization.verified) {
            (async function loadEmployees() {
                await appContext.setEmployees();
            })();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setNumEmployees(appContext.employees.filter(emp => {return emp.role === 'employee' || emp.role === 'perk-manager'}).length)
    }, [appContext.employees])

    useEffect(() => {
        const itemList = location.pathname.split("/")
        const currentItem = itemList[1]
        setActiveItem(currentItem === 'account' ? 
                            "Account"
                        :
                            currentItem === 'programs' ?
                                "Programs"
                            :
                                currentItem === 'tools' ?
                                    "Tools"
                                :
                                    currentItem === 'analytics' ?
                                        "Analytics"
                                    :
                                        currentItem === 'settings' ?
                                            "Settings"
                                        :
                                            currentItem === 'faq' ?
                                                "FAQ"
                                            :
                                                "Home"
                            )
    }, [location.pathname])


    useEffect(() => {
        const hasSomeBudget = appContext.organization.availableBudget > 0 || appContext.organization.expectedFundAvailability;
        console.info({hasSomeBudget});
        setHasSomeBudget(hasSomeBudget);
    }, [appContext.organization.availableBudget, appContext.organization.expectedFundAvailability]);

    const handleOnUpdate = (e, {width}) => {
        setScreenWidth(width);
    };

    const handleItemClick = (e) => {
        const name = e.target.innerText;
        console.log({name})
        setActiveItem(name);
        let routeLink = name.trim().toLowerCase().replace(' ', '-');
        console.info({routeLink});
        // if (routeLink === 'perks') return history.push(`/perks/programs/active`);
        // if (routeLink === 'expenses') return history.push(`/expenses/programs/active`);
        history.push(routeLink === 'home' ? '/' : `/${routeLink}`);
    };

    const initiateFund = async () => {
        console.info(`starting the program...`);
        if (appContext.organization.fundedOnce) return toast.dark(`Already funded.`);
        setFundLoading(true);

        const API = axios.create({baseURL, headers: {'Authorization': `Bearer ${accessToken}`},});

        const planId = selectedSubscriptionPlanValue; // basic|essential|premium
        const response = await API.post(`/fund-organization`, {budget: requiredFund}).catch(error => {
            console.info({error});
            setShowConfirmFundModal(false);
            if (error.isAxiosError && error.response.data && error.response.data.status) {
                console.info(error.response.data.status);
                const {code, message} = error.response.data.status;
                console.info({code});
                toast.error(message);
                setFundLoading(false);
                return error.response.data.status;
            } else {
                toast.error(`There was an error. Please try again later.`);
                setFundLoading(false);
            }
        });
        if (response && response.data && response.data.status) {
            const {code, message} = response.data.status;
            const {availableBudget, expectedAvailability} = response.data;
            console.info({availableBudget, expectedAvailability});
            console.info({code, message});
            toast.success(message);
            if (code === `organization/funded`) await appContext.setOrganizationPartialInfo({
                ...appContext.organization,
                fundedOnce: true,
                expectedFundAvailability: expectedAvailability,
                availableBudget: availableBudget
            });
            setFundLoading(false);
            setShowConfirmFundModal(false);
        }
    }

    const loadFundOrgModal = async (e) => {
        console.info(`loading fund org modal..`);
        setShowConfirmFundModal(true);
        if (appContext.employees.length === 0) {
            setFundLoading(true);
            await appContext.setEmployees();
            setFundLoading(false);
        }
    }

    const AvailableBudgetStatus = (props) => {
        return (
            <>
                {fundLoading ? (<div className="ui active inline loader center aligned fund-processing"/>) :
                    (<div className="ui container sidebar-budget-status">
                        {hasSomeBudget ?
                            (<div className="item">
                                {!appContext.organization.expectedFundAvailability ? (<p>Available Balance:</p>) : (
                                    <p>Will be available by {appContext.organization.expectedFundAvailability}:</p>)}
                                <h5>${appContext.organization.availableBudget}</h5>
                            </div>) :
                            (
                                <div className="item">
                                    <p>Launch Your Account:</p>
                                    <button className="ui button primary" disabled={fundLoading} onClick={loadFundOrgModal}>Fund Org</button>
                                    {/*// TODO: should be hidden if funded successfully & show the amount instead */}
                                </div>
                            )
                        }
                    </div>)}
            </>
        )
    }

    const calculateSubscriptionFee = (e, {value}) => {
        const selectedPlan = subscriptionPlans.filter(plan => plan.value === value)[0];
        console.info({selectedPlan});
        setSelectedSubscriptionPlanTitle(selectedPlan.text);
        setSelectedPlanPrice(selectedPlan.price);

        /*switch (value) {
            case 'basic_plan':

                break;
            case 'essential_plan':
                break;
            case 'premium_plan':
                break;
        }*/
        setSelectedSubscriptionPlanValue(value);
    }

    return (
        // <Responsive fireOnMount onUpdate={handleOnUpdate} style={{backgroundColor: 'rgba(251, 251, 251, 1)', height: '91.5vh'}}>
        <Responsive fireOnMount onUpdate={handleOnUpdate} style={{backgroundColor: 'rgba(251, 251, 251, 1)', height: '100%', width: '100%'}}>
            <div id="main-nav" style={{height: '100%'}}>
                <div style={{height: '8vh', width: '100%', display: 'flex', paddingLeft: 40}}>
                    <Image size="mini" src={require("./Perkfix_logo_black_no_bg.png")} style={{alignSelf: 'center' }} />
                </div>
                <div style={{width: '100%', height: '49vh'}}>
                    <Grid padded='vertically' style={{paddingTop: 0, marginTop: 0}} >
                        <Grid.Row>
                            <Grid.Column>
                                {/* <Segment.Group basic style={{borderWidth: 0}}> */}
                                    <Segment basic style={{
                                                backgroundColor: activeItem === 'Home' ? 'rgba(0, 200, 136, 1)' : "transparent", 
                                                paddingLeft: 0, paddingRight: 0,
                                                height: '15%', maxHeight: 35, borderWidth: 0, paddingTop: 0}}
                                            className={`sidebar-option ${activeItem === 'Home' ? 'sidebar-item-active' : ''}`}>
                                        <Button onClick={handleItemClick} fluid disabled={!appContext.organization.verified} style={{paddingLeft: 10, backgroundColor: 'transparent', borderRadius: 0, paddingRight: 0,
                                                    color: activeItem === 'Home' ? 'white' : 'rgba(34, 34, 34, 1)'}}>
                                                <Icon fitted name="home" style={{float: 'left', marginTop: 0, width: 20}}   />
                                                <span style={{marginLeft: 10, fontSize: 14, fontStyle: 'SFProText-Regular', float: 'left', marginRight: 0}}>
                                                    Home
                                                </span>
                                        </Button>
                                    </Segment>
                                    <Segment basic style={{
                                                backgroundColor: activeItem === 'Account' ? 'rgba(0, 200, 136, 1)' : "transparent", 
                                                paddingLeft: 0, paddingRight: 0,
                                                height: 35, borderWidth: 0, paddingTop: 0}}
                                            className={`sidebar-option ${activeItem === 'Account' ? 'sidebar-item-active' : ''}`}>
                                        <Button onClick={handleItemClick} fluid style={{paddingLeft: 10, backgroundColor: 'transparent', borderRadius: 0, paddingRight: 0,
                                                    color: activeItem === 'Account' ? 'white' : 'rgba(34, 34, 34, 1)'}}>
                                                <Icon fitted name="briefcase" style={{float: 'left', marginTop: 0, width: 20}}  />
                                                <span style={{marginLeft: 10, fontSize: 14, fontStyle: 'SFProText-Regular', float: 'left', marginRight: 0}}>
                                                    Account
                                                </span>
                                        </Button>
                                    </Segment>
                                    <Segment basic style={{
                                                backgroundColor: activeItem === 'Programs' ? 'rgba(0, 200, 136, 1)' : "transparent", 
                                                paddingLeft: 0, paddingRight: 0,
                                                height: 35, borderWidth: 0, paddingTop: 0}}
                                            >
                                        <Button onClick={handleItemClick} fluid disabled={!appContext.organization.verified} style={{paddingLeft: 10, backgroundColor: 'transparent', borderRadius: 0, paddingRight: 0,
                                                    color: activeItem === 'Programs' ? 'white' : 'rgba(34, 34, 34, 1)'}}>
                                                <Icon fitted name="handshake" style={{float: 'left', marginTop: 0, width: 20}}  />
                                                <span style={{marginLeft: 10, fontSize: 14, fontStyle: 'SFProText-Regular', float: 'left', marginRight: 0}}>
                                                    Programs
                                                </span>
                                        </Button>
                                    </Segment>
                                    <Segment basic style={{
                                                backgroundColor: activeItem === 'Tools' ? 'rgba(0, 200, 136, 1)' : "transparent", 
                                                paddingLeft: 0, paddingRight: 0,
                                                height: 35, borderWidth: 0, paddingTop: 0}}
                                            className={`sidebar-option ${activeItem === 'Tools' ? 'sidebar-item-active' : ''}`}>
                                        <Button onClick={handleItemClick} fluid disabled={!appContext.organization.verified}  style={{paddingLeft: 10, backgroundColor: 'transparent', borderRadius: 0, paddingRight: 0,
                                                    color: activeItem === 'Tools' ? 'white' : 'rgba(34, 34, 34, 1)'}}>
                                                <Icon fitted name="wrench" style={{float: 'left', marginTop: 0, width: 20}}  />
                                                <span style={{marginLeft: 10, fontSize: 14, fontStyle: 'SFProText-Regular', float: 'left', marginRight: 0}}>
                                                    Tools
                                                </span>
                                        </Button>
                                    </Segment>
                                    <Segment basic style={{
                                                backgroundColor: activeItem === 'Analytics' ? 'rgba(0, 200, 136, 1)' : "transparent", 
                                                paddingLeft: 0, paddingRight: 0,
                                                height: 35, borderWidth: 0, paddingTop: 0}}
                                            className={`sidebar-option ${activeItem === 'Analytics' ? 'sidebar-item-active' : ''}`}>
                                        <Button onClick={handleItemClick} fluid disabled={!appContext.organization.verified}  style={{paddingLeft: 10, backgroundColor: 'transparent', borderRadius: 0, paddingRight: 0,
                                                    color: activeItem === 'Analytics' ? 'white' : 'rgba(34, 34, 34, 1)'}}>
                                                <Icon fitted name="pie chart" style={{float: 'left', marginTop: 0, width: 20}}  />
                                                <span style={{marginLeft: 10, fontSize: 14, fontStyle: 'SFProText-Regular', float: 'left', marginRight: 0}}>
                                                    Analytics
                                                </span>
                                        </Button>
                                    </Segment>
                                {/* </Segment.Group> */}
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    {/* </Container> */}
                </div>
                <div style={{width: '100%', height: '29vh'}}>
                    {appContext.organization.verified ? 
                        <AvailableBudgetStatus/>
                    :null}
                </div>
                <div style={{width: '100%', height: '13vh', verticalAlign: 'bottom'}}>
                    <Grid padded='vertically' style={{verticalAlign: 'bottom'}}>
                        <Grid.Row style={{}}>
                            <Grid.Column>
                                <Segment basic style={{
                                            backgroundColor: activeItem === 'Settings' ? 'rgba(0, 200, 136, 1)' : "transparent", 
                                            paddingLeft: 0, paddingRight: 0,
                                            height: 35, borderWidth: 0, paddingTop: 0}}
                                        className={`sidebar-option ${activeItem === 'Settings' ? 'sidebar-item-active' : ''}`}>
                                    <Button onClick={handleItemClick} fluid disabled={!appContext.organization.verified}  style={{paddingLeft: 10, backgroundColor: 'transparent', borderRadius: 0, paddingRight: 0,
                                                color: activeItem === 'Settings' ? 'white' : 'rgba(34, 34, 34, 1)'}}>
                                            <Icon fitted name="setting" style={{float: 'left', marginTop: 0, width: 20}} />
                                            <span style={{marginLeft: 10, fontSize: 14, fontStyle: 'SFProText-Regular', float: 'left', marginRight: 0}}>
                                                Settings
                                            </span>
                                    </Button>
                                </Segment>
                                <Segment basic style={{
                                            backgroundColor: activeItem === 'FAQ' ? 'rgba(0, 200, 136, 1)' : "transparent", 
                                            paddingLeft: 0, paddingRight: 0,
                                            height: 35, borderWidth: 0, paddingTop: 0}}
                                        className={`sidebar-option ${activeItem === 'FAQ' ? 'sidebar-item-active' : ''}`}>
                                    <Button onClick={handleItemClick} fluid style={{paddingLeft: 10, backgroundColor: 'transparent', borderRadius: 0, paddingRight: 0,
                                                color: activeItem === 'FAQ' ? 'white' : 'black'}}>
                                            <Icon fitted name="info circle" style={{float: 'left', marginTop: 0, width: 20}} />
                                            <span style={{marginLeft: 10, fontSize: 14, fontStyle: 'SFProText-Regular', float: 'left', marginRight: 0}}>
                                                FAQ
                                            </span>
                                    </Button>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>
            </div>

            <Modal className="fund-org-modal" onClose={() => setShowConfirmFundModal(false)} onOpen={() => setShowConfirmFundModal(true)} open={showConfirmFundModal} closeOnEscape={false}
                   closeOnDimmerClick={false}>
                {fundLoading && (<Dimmer active>
                    <Loader size="large">loading...</Loader>
                </Dimmer>)}
                <Modal.Header>Funding information</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        <p>With the below confirmation we will initiate amount transfer request:</p>
                        <ol>
                            <li>Application Subscription fee</li>
                            <li>Monthly budget available to spend to your employees</li>
                        </ol>

                        <h4>Your subscription plan:</h4>
                        {/* <hr/>
                        <Dropdown options={subscriptionPlans} onChange={calculateSubscriptionFee} value={selectedSubscriptionPlanValue} required/>
                        <hr/> */}
                        {/*<h4>Total Number of employees: {appContext.employees.length}</h4>*/}
                        <p><strong>{selectedSubscriptionPlanTitle}</strong> X <strong>number of employees ({numEmployees})</strong></p>

                        <p>Your total subscription fee for the month: ${(selectedPlanPrice * (numEmployees)).toFixed(2)}</p>

                        <h4>Your Top-Up amount:</h4>
                        <p>Your total Account Top-Up for the month: ${requiredFund.toFixed(2)} ({numEmployees} employees)</p>

                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <button className="ui button primary" onClick={initiateFund}>Initiate Funds</button>
                    <button className="ui button" onClick={() => setShowConfirmFundModal(false)}>Cancel</button>
                </Modal.Actions>
            </Modal>

        </Responsive>
    );
};
